import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accesibilidad',
  templateUrl: './accesibilidad.component.html',
  styleUrls: ['./accesibilidad.component.css']
})
export class AccesibilidadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
